import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from "../../components/Footer";
import {useLang} from "../../context/LanguageContext";


const Faq = () => {
  const navigate = useNavigate();
  const { t } = useLang();

  const faqData = [
    {
      question: t("txt.faqQ1"),
      answer: t("txt.faqA1"),
    },
    {
      question: t("txt.faqQ2"),
      answer: t("txt.faqA2"),
    },
    {
      question: t("txt.faqQ3"),
      answer: t("txt.faqA3"),
    },
    {
      question: t("txt.faqQ4"),
      answer: t("txt.faqA4"),
    },
    {
      question: t("txt.faqQ5"),
      answer: t("txt.faqA5"),
    }
  ];

  return (
    <div 
      className="relative bg-cover bg-no-repeat bg-center bg-fixed min-h-screen" 
      style={{ backgroundImage: "url('/assets/images/laponturi-bg2.webp')" }}
    >
      {/* Back Button */}
     

      <div className="absolute inset-0 bg-[#34495e] opacity-50 z-10"></div>
      <div className="relative z-20">

      <button
        onClick={() => navigate(-1)}
        className="absolute top-5 left-5 px-4 py-2 bg-gray-300 rounded z-10"
      >
        Back
      </button>

      {/* Content Wrapper */}
      <div className="px-5 pt-16 pb-10 max-w-[600px] mx-auto">
        <h1 className="text-white text-2xl font-bold mb-5">FAQ</h1>
        
        {faqData.map((item, index) => (
          <div key={index} className="bg-white rounded shadow p-4 mb-4">
            <h2 className="font-semibold mb-2">{item.question}</h2>

            {item.question === t("txt.faqQ5") ? (
              <p className="text-sm text-gray-700">
                {/* Make the text clickable */}
                <span 
                  onClick={() => navigate('/terms')} 
                  className="text-blue-600 underline cursor-pointer"
                >
                  {item.answer}
                </span>
              </p>
            ) : (
              <p className="text-sm text-gray-700">{item.answer}</p>
            )}
          </div>
        ))}
      </div>
        <Footer />
      </div>
    </div>
  );
};

export default Faq;
